import { render } from "./KPIDeviation.vue?vue&type=template&id=2d79fc2d&scoped=true"
import script from "./KPIDeviation.vue?vue&type=script&lang=js"
export * from "./KPIDeviation.vue?vue&type=script&lang=js"

import "./KPIDeviation.vue?vue&type=style&index=0&id=2d79fc2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d79fc2d"]])

export default __exports__